import React from 'react';

export const ReferEarnWheelKeyframeStyles = () => (
  <style>{`
    @keyframes refer-earn-light-pulse-odd {
      0%, 12.5% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      25%, 37.5% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.88);
      }
      50%, 62.5% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      75%, 87.5% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.88);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
    @keyframes refer-earn-light-pulse-even {
      0%, 12.5% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.88);
      }
      25%, 37.5% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      50%, 62.5% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.88);
      }
      75%, 87.5% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      100% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.88);
      }
    }
    @keyframes refer-earn-win-burst {
      0% {
        opacity: 1;
        transform: scale(1);
        filter: brightness(1) drop-shadow(0 0 0 rgba(255, 233, 120, 0));
      }
      28% {
        opacity: 1;
        transform: scale(1.065);
        filter: brightness(1.16) drop-shadow(0 0 16px rgba(255, 233, 120, 0.88));
      }
      58% {
        opacity: 1;
        transform: scale(1.018);
        filter: brightness(1.08) drop-shadow(0 0 11px rgba(255, 233, 120, 0.6));
      }
      100% {
        opacity: 1;
        transform: scale(1);
        filter: brightness(1) drop-shadow(0 0 8px rgba(255, 233, 120, 0.42));
      }
    }
    @keyframes refer-spin-backin-breathe {
      0%, 100% {
        opacity: 0.9;
        transform: translate(-50%, -50%) scale(1);
        filter: brightness(1) saturate(1);
      }
      50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.025);
        filter: brightness(1.08) saturate(1.04);
      }
    }
    .refer-spin-backin {
      animation: refer-spin-backin-breathe 4.2s ease-in-out infinite;
      transform-origin: center;
      will-change: transform, opacity, filter;
    }
    @media (prefers-reduced-motion: reduce) {
      .refer-spin-backin {
        animation: none;
      }
    }
  `}</style>
);
